import { useState, useEffect } from 'react'
import axios from 'axios'
import { Select } from 'antd'

const FilterAlmamaterVisit = ({
  filterValue,
  setFilterValue,
  setCurrentPage
}) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [tempfilterValue, setTempFilterValue] = useState({})
  const [categoryFilter, setCategoryFilter] = useState([])
  const [teamFilter, setTeamFilter] = useState([])

  useEffect(() => {
    getFilter()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid])

  const getFilter = (value) => {
    axios.post('/p/almamater_visit/member/filter', { 
      merchant_oid: merchantOid,
      category_oid: value || ''
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setCategoryFilter(response.data.categories)
          setTeamFilter(response.data.teams)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }


  let categoryItems = [
    {  
      value: '', 
      label: '全部'
    },
    ...categoryFilter.map((item) => (
      {
        value: item.oid,
        label: item.name
      }
    ))
  ]

  let teamItems = [
    {  
      value: '', 
      label: '全部'
    },
    ...teamFilter.map((item) => (
      {
        value: item.oid,
        label: item.name
      }
    ))
  ]

  const clickCategoryFilter = (value) => {
    setTempFilterValue({ ...tempfilterValue, category: value, team: ''})
    getFilter(value)
  }

  const clickTeamFilter = (value) => {
    setTempFilterValue({ ...tempfilterValue, team: value})
  }

  const clickSubmitFilter = () => {
    setFilterValue({ ...filterValue, ...tempfilterValue })
    setCurrentPage(1)
  }

  const clickResetFilter = () => {
    setFilterValue({ ...filterValue, category: '', college: '', major: '', class: '', remark: '', photo: 0, status: 0 })
    getFilter()
    setTempFilterValue({})
  }

  return (
    <div className='public-conditions'>
      <div className='public-conditions-row'>
        <div className='public-condition'>
          <div className='public-condition-label'>选择分类：</div>
          <Select
            value={tempfilterValue.category}
            placeholder="请选择"
            options={categoryItems}
            style={{width: '220px'}}
            onChange={(value) => clickCategoryFilter(value)}
          />
        </div>

        <div className='public-condition'>
          <div className='public-condition-label'>选择团队：</div>
          <Select
            value={tempfilterValue.team}
            placeholder="请选择"
            options={teamItems}
            style={{width: '220px'}}
            onChange={(value) => clickTeamFilter(value)}
          />
        </div>
      </div>

      <div className='public-conditions-buttons'>
        <div className='public-conditions-button1' onClick={() => { clickSubmitFilter() }}>筛选</div>
        <div className='public-conditions-button2' onClick={() => { clickResetFilter() }}>重置</div>
      </div>
    </div>
  )
}

export default FilterAlmamaterVisit
